// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__VYaaH","header":"Privacy_header__belNq","privacy":"Privacy_privacy__myMN0"};